import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import notification from './modules/notification'
import report from './modules/report'
import place from './modules/place'
import accommodation from './modules/accommodation'
import stop from './modules/stop'
import itinerary from './modules/itinerary'
import trip from './modules/trip'
import review from './modules/review'
import options from './modules/options'
import alert from './modules/alert'
import versionControl from './modules/version-control'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    place,
    accommodation,
    stop,
    itinerary,
    trip,
    review,
    alert,
    options,
    notification,
    report,
    versionControl
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
